
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...mtgAgentDetailsEN]",
      function () {
        return require("private-next-pages/[...mtgAgentDetailsEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...mtgAgentDetailsEN]"])
      });
    }
  